/* eslint-disable max-classes-per-file */

import BlockComponentText from '../../../../models/BlockComponentValues/BlockComponentText';
import LinkData from '../../../../models/LinkData';
import BlockComponentImage from '../../../../models/BlockComponentValues/BlockComponentImage';

class BlockHeaderData {
  title?: BlockComponentText;
  menus?: LinkData[];
  url?: BlockComponentImage;
  isFree?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockHeaderData {
  export function make(isFree?: boolean, title?: string, menus?: LinkData[], url?: string): BlockHeaderData {
    return {
      isFree,
      title: title ? BlockComponentText.make(title) : undefined,
      menus,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(isFree = false, title = 'ヘッダー'): BlockHeaderData {
    return make(
      isFree,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      [
        LinkData.getDefault('メニュー1'),
        LinkData.getDefault('メニュー2'),
        LinkData.getDefault('メニュー3'),
      ],
    );
  }
}

export default BlockHeaderData;
